const isLocalTest = false;

const FRONT_URL = isLocalTest ? "http://localhost:3000" : "https://screenplayer.co.uk";
const BACK_URL = isLocalTest ? "http://127.0.0.1:8000" : "https://screenplayer.co.uk";
const API_URL = `${BACK_URL}/api`;
const APP_URL = `${FRONT_URL}/app`;

export { API_URL, FRONT_URL, APP_URL, BACK_URL };
